import React, { ReactElement } from 'react';
import ListItem from './list-item';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MapState } from '../../map/reducer';
import { SelectedKrets } from '../../../../catalog/krets-actions';
import Sorting from './sorting';
import { portAndWaterwayObjectSorter } from '../../../../utils';
import { UseParams } from '../../../../types';

const DEFAULT_TITLE = 'Hamn & Farleds-objekt';

export default function PortAndWaterwayObjectList(): ReactElement {
  const { items, filterText, selectedKrets, sortGeo } = useSelector((state: { map: MapState; selectedKrets: SelectedKrets[] }) => ({
    items: [].concat(state.map.objects),
    filterText: state.map.filterText,
    selectedKrets: state.selectedKrets,
    sortGeo: state.map.sortGeo,
  }));
  items.sort(portAndWaterwayObjectSorter(sortGeo));
  const { slug }: UseParams = useParams();
  let filteredItems = items.filter((o) => !slug || slug === 'alla' || slug === o.type);
  if (filterText) {
    const m = new RegExp(filterText, 'gi');
    filteredItems = filteredItems.filter((item) => m.test(item.name + ' ' + item.description));
  }
  if (selectedKrets && selectedKrets.length > 0) {
    const selected = selectedKrets.map((item) => item.value);
    filteredItems = filteredItems.filter((item) => selected.includes(item.organizationId));
  }

  const title = !slug || slug === 'alla' ? DEFAULT_TITLE : filteredItems[0]?.typeName || DEFAULT_TITLE;
  return (
    <div className="ts-activity-item">
      <div className="ts-activity-item-title page-title-box">
        <div
          className="ts-activity-item-title-wrap page-title-box-inner content-bg"
          style={{
            display: 'flex',
            flexFlow: 'row',
            justifyContent: 'space-between',
          }}
        >
          <h1>{title}</h1>
          <Sorting />
        </div>
      </div>
      <div className="ts-activity-item-scroll-outer">
        <div className="scroll-wrapper ts-activity-item-scroll scrollbar-inner">
          <div>
            {filteredItems.map((item) => (
              <ListItem key={item.id} {...item} />
            ))}
          </div>
        </div>
      </div>
      <button onClick={() => history.back()}>Tillbaka</button>
    </div>
  );
}
